export const isPlayerFavourite = (playerId: string, favPlayerIds?: string[]) =>
  (favPlayerIds || []).some(id => String(id) === String(playerId));

type SortablePlayer = {
  _id: string;
  name?: string;
  lastName?: string;
};

export const sortPlayersBySearchPriority = <T extends SortablePlayer>(
  players: T[],
  options: { favPlayerIds?: string[]; rosterPlayerIds?: Iterable<string> },
): T[] => {
  const favSet = new Set((options.favPlayerIds || []).map(String));
  const rosterSet = new Set([...(options.rosterPlayerIds || [])].map(String));

  const tier = (player: T) => {
    const id = String(player._id);
    if (favSet.has(id)) return 0;
    if (rosterSet.has(id)) return 1;
    return 2;
  };

  const label = (player: T) => `${player.name || ""} ${player.lastName || ""}`.trim().toLowerCase();

  return [...players].sort((a, b) => {
    const tierDiff = tier(a) - tier(b);
    if (tierDiff !== 0) return tierDiff;
    return label(a).localeCompare(label(b));
  });
};
